/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_SubtitleInputs */

const vi_tea_grade_subtitle = /** @type {(inputs: Tea_Grade_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý danh sách phân loại (Đặc biệt, A, B, C, Vụn ...).`)
};

/**

* @param {Tea_Grade_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_subtitle = /** @type {((inputs?: Tea_Grade_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_subtitle(inputs)
});